import React, { Component } from 'react'
import PropTypes from 'prop-types'
import BoxCol from './StyledBoxCol'
import FutroLink from './StyledFutroLink'
import ImageWrapper from './StyledImageWrapper'
import FutroImage from './StyledFutroImage'
import Discount from './StyledDiscount'
import TitleWrapper from './StyledTitleWrapper'
import TextRow from './StyledTextRow'
import Price from './StyledPrice'
import MoreButton from './StyledMoreButton'

class FutroBox extends Component {
  constructor (props) {
    super(props)
    this.handleAnchorClick = this.handleAnchorClick.bind(this)
  }

  componentDidMount () {
    const {
      box: {
        guid: id,
        title: name,
        source: category
      },
      googleAnalytics,
      position
    } = this.props

    const impressionFieldObject = {
      id,
      name,
      category,
      list: 'futro',
      position
    }

    googleAnalytics.addImpression(impressionFieldObject)
  }

  handleAnchorClick (event, location) {
    event.preventDefault()

    const {
      box: {
        guid: id,
        title: name,
        source: category
      },
      googleAnalytics
    } = this.props
    const purchaseFieldObject = {
      id,
      name,
      category
    }

    googleAnalytics.handlePurchaseEvent(purchaseFieldObject).then(() => {
      document.location.href = location
    }).catch(() => {
      document.location.href = location
    })
  }

  render () {
    const {
      box: {
        discount,
        image,
        link,
        title
      }
    } = this.props

    const priceStart = title.indexOf('{')
    const titleWithoutPrice = title.slice(0, priceStart)
    const price = title.slice(priceStart + 1, title.length - 1)

    return (
      <BoxCol sm={4}>
        <FutroLink
          href={link}
          onClick={event => {
            this.handleAnchorClick(event, link)
          }}
        >
          <ImageWrapper>
            <FutroImage src={image} alt={title}/>
            <Discount>
              -{ discount }%
            </Discount>
          </ImageWrapper>
          <TextRow>
            <TitleWrapper>
              { titleWithoutPrice }
              <Price>
                { price }
              </Price>
            </TitleWrapper>
            <MoreButton>
              <span>Zjistěte</span> více
            </MoreButton>
          </TextRow>
        </FutroLink>
      </BoxCol>
    )
  }
}

FutroBox.propTypes = {
  box: PropTypes.object.isRequired
}

export default FutroBox
